import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioManualValueResponseDTO,
	type ClientPortfolioManualValueSaveRequestDTO,
	putPortfolioIdManualValueV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePutPortfolioManualValueMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		ClientPortfolioManualValueResponseDTO,
		Error,
		ClientPortfolioManualValueSaveRequestDTO
	>({
		mutationFn: processResponse((requestContract) =>
			putPortfolioIdManualValueV2(requestContract, id),
		),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioList(),
			});
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.reporting(id),
			});
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioDetail(id),
			});
		},
	});
};
